import { fetchApi } from "../utils/apiUtils";

export const timeZoneListfetch = async (accessToken) => {
  try {
    const response = await fetchApi(`timezone/list/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      requiresAuth: true
    });


    return response;
  } catch (error) {
    return error

  } finally {
    //   setLoading(false); // Hide loading indicator
  }

}

export const languageListfetch = async () => {
  try {
    const response = await fetchApi(`language/list/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      requiresAuth: true
    });


    return response;
  } catch (error) {
    return error

  } finally {
    //   setLoading(false); // Hide loading indicator
  }

}